import { render, staticRenderFns } from "./ai-message.vue?vue&type=template&id=9c5808c2&lang=html"
import script from "./ai-message.vue?vue&type=script&lang=js"
export * from "./ai-message.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports